import React from 'react';
import ModalTerc from 'react-responsive-modal';

import './styles.css';

const Modal = ({ open, mt, onClose, children, widthModal }) => (


    <ModalTerc
        classNames={{
          overlay:'modal-overlay',
          modal: mt ? 'modal-container2' : 'modal-container',
          closeIcon:'closed-icon',
          transitionEnter: 'transition-enter',
          transitionEnterActive: 'transition-enter-active',
          transitionExit: 'transition-exit-active',
          transitionExitActive: 'transition-exit-active',
        }}
        animationDuration={1000}
        closeIconSize={40}
        closeIconSvgPath ={ <path d="M20.1096151,17.5 L24.4544145,21.8447994 C25.1775577,22.5679426 25.184623,23.7333242 24.4589736,24.4589736 C23.7383483,25.1795989 22.5738487,25.1834638 21.8447994,24.4544145 L17.5,20.1096151 L13.1552006,24.4544145 C12.4320574,25.1775577 11.2666758,25.184623 10.5410264,24.4589736 C9.8204011,23.7383483 9.81653616,22.5738487 10.5455855,21.8447994 L14.8903849,17.5 L10.5455855,13.1552006 C9.8224423,12.4320574 9.81537704,11.2666758 10.5410264,10.5410264 C11.2616517,9.8204011 12.4261513,9.81653616 13.1552006,10.5455855 L17.5,14.8903849 L21.8447994,10.5455855 C22.5679426,9.8224423 23.7333242,9.81537704 24.4589736,10.5410264 C25.1795989,11.2616517 25.1834638,12.4261513 24.4544145,13.1552006 L20.1096151,17.5 Z" id="Combined-Shape" fill="#9B9B9B"></path>}
        open={open}
        onClose={onClose} center>
        {children}
    </ModalTerc>
);

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.js